<template>
  <v-dialog
    v-model="opened"
    content-class="update-type"
    max-width="350"
    persistent
  >
    <h3 class="update-type__title">
      {{ $t('common.btns.edit') }}
    </h3>

    <v-btn class="close-btn" icon @click="opened = false">
      <v-icon size="27" color="#464646"> mdi-close-circle-outline </v-icon>
    </v-btn>

    <v-form ref="update-type-form" class="mt-3" @submit.prevent="onSubmit">
      <expense-type-select
        v-model="formData.finance_type_id"
        dense
        outlined
        :disabled="categoryOnly"
        :rules="[isRequired]"
      />
      <type-category-select
        v-model="formData.finance_type_category_id"
        dense
        outlined
        :type-id="formData.finance_type_id"
        :rules="[isRequired]"
      />

      <v-btn
        type="submit"
        color="warning"
        elevation="0"
        block
        :loading="loading"
      >
        {{ $t('common.btns.save') }}
      </v-btn>
    </v-form>
  </v-dialog>
</template>

<script>
import ExpenseTypeSelect from './ExpenseTypeSelect.vue';
import TypeCategorySelect from './TypeCategorySelect.vue';

export default {
  components: { ExpenseTypeSelect, TypeCategorySelect },
  model: {
    prop: 'value',
    event: 'change',
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    typeId: {
      type: [Number, String],
      required: true,
    },
    categoryId: {
      type: [Number, String],
    },
    itemId: {
      type: [Number, String],
      required: true,
    },
    categoryOnly: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    loading: false,

    formData: {
      finance_type_id: '',
      finance_type_category_id: '',
    },
  }),
  watch: {
    opened(value) {
      if (!value) {
        this.$refs['update-type-form'].reset();
        this.loading = false;
        return;
      }

      this.formData.finance_type_id = this.typeId;
      this.formData.finance_type_category_id = this.categoryId || '';
    },
  },
  computed: {
    opened: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('change', val);
      },
    },
  },
  methods: {
    isRequired(v) {
      return !!v || this.$t('common.fields.validation.field.required');
    },
    async onSubmit() {
      const isValid = this.$refs['update-type-form'].validate();

      if (!isValid) return;

      this.loading = true;
      this.$emit('save', {
        params: this.formData,
        id: this.itemId,
      });
    },
  },
};
</script>

<style lang="scss">
.update-type {
  padding: 10px;
  background-color: #fff;
}
</style>
